






















































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import TableComponent from './Components/PersonnelTable.vue';
import ImportLog from '@/components/common/ValidationMessage/ImportLog.vue';
import HeaderInfo from '../../ExpansionPanel/FinExpansionPanel.vue';
import NavButtons from '@/components/common/Buttons/NavButtons.vue';

const namespace: string = "financialReport";
@Component({
  components: {
    TableComponent,
    FormattedNumber,
    HeaderInfo,
    NavButtons,
    ImportLog
  }
})
export default class PersonnelCostComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;
  @Getter('selectedReport', {namespace}) report: any;
  @Getter('grantInfo', {namespace}) grantInfo: any;
  @Prop() financialReportSections: any;
  @Prop() validations: any
  @Prop() model: any;
  @Prop() readonly: any;
  @Prop() schema: any;
  @Prop() formOptions: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() currency: string;
  @Prop() enableButton: any;
  @Prop() validationImport: boolean;

  mounted() {}

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find(x => x.RowKey === rowKey);
    } else {
        return null;
    }
  }

  get dataModel() {
    if (!this.model.personnelCost) {
      this.model.personnelCost = [];
    }
    return this.model.personnelCost;
  }

  get attachedDocs() {
    const docs = this.model.finReportDocuments || [];
    const filteredDocs = docs.filter(doc => doc.name && Object.keys(doc).length > 0);
    return filteredDocs.length ? filteredDocs : null;
  }

  get header() {
    if(this.schema && this.schema.properties && this.schema.properties.personnelHeaders) {
      return this.schema.properties.personnelHeaders.items
    }
  }

  get currencyList() {
    return this.financialReport.currencyList;
  }

  get budget() {
    let obj: any = {};
    if (
      this.financialReport.grantData &&
      this.financialReport.grantData.applicationBudget
    ) {
      obj = this.financialReport.grantData.applicationBudget;
    }
    return obj;
  }

  get personnelCostRowDatas() {
    if (this.budget && this.budget.data_row) {
      var filteredList = this.budget.data_row.filter((e) => e.category_id == "1" && e.descr && e.descr !== null);
      const myNewArray = filteredList.map((item, index) =>  { return item.descr } );
      return myNewArray;
    }
  }

  get budgetCategories() {
    return this.financialReport.categories;
  }

  resolve(obj) {
    var formulaErrors: Array<any> = this.validations.filter(x => x.validationType === 'formula');
    var self = this;
    formulaErrors.forEach((x: any) => {
      if(self.dataModel[x.rowIndex]){ 
        // @ts-ignore
        self.$refs.childComp.findTotalCost(self.dataModel[x.rowIndex]);
      }
    })
    this.$emit('resolvedError', this.validations.filter(x => x.validationType !== 'formula') )
    }
}
